module.exports = __webpack_public_path__ + "static/img/imp.6c26fbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sdk/imp.png
// module id = Y2aW
// module chunks = 1